import handleEvent from 'utilities/handleEvent';

import styles from './styles.module.scss';

const Icon = ({
    alt = '',
    className = '',
    image = '',
    onClick,
    onKeyDown,
    onMouseEnter = e => {},
    tabIndex = ''
}) => {
    const handleClick = onClick => handleEvent(onClick);
    const handleKeyDown = onKeyDown => handleEvent(onKeyDown);
    return (
        <img
            alt={alt}
            className={`${className} ${styles.icon}`}
            onClick={handleClick(onClick)}
            onKeyDown={handleKeyDown(onKeyDown)}
            src={image}
            onMouseEnter={onMouseEnter}
            tabIndex={tabIndex}
        />
    );
};

export default Icon;
